<template>
  <article
    itemscope="itemscope"
    itemtype="http://schema.org/Product"
    class="tile"
  >
    <!-- Meta -->
    <meta itemprop="url" :content="host + product.url" />
    <meta
      itemprop="image"
      :content="host + product.thumbnail || '/public/fallback.gif'"
    />

    <!-- Variant badge -->
    <div class="tile__image-badge" v-if="product.variants > 1">
      {{ product.variants }} {{ dict["varianter"] }}
    </div>

    <!-- Image -->
    <picture>
      <source
        :srcset="image(product.thumbnail, '&format=webp&quality=85')"
        type="image/webp"
      />
      <img
        itemprop="image"
        loading="lazy"
        width="268"
        height="179"
        :src="image(product.thumbnail)" 
        :alt="product.name"
        class="img-fluid"
      />
    </picture>

    <div class="tile__txt">
      <div v-if="product.isNewProduct" class="tile__txt-badge">Nyhed</div>

      <!-- Name -->
      <h3
        class="tile__headline"
        itemprop="name"
        :data-product-name="product.name"
      >
        <a @click="onClick(product, $event)" :href="product.url">
          {{ product.name }}
          <small v-if="product.name2">
            {{ product.name2 }}
          </small>
        </a>
      </h3>

      <!-- Price -->
      <div
        class="tile__prices"
        itemprop="offers"
        itemscope="itemscope"
        itemtype="http://schema.org/Offer"
      >
        <span itemprop="priceCurrency" :content="settings.currency"></span>
        <span
          v-if="product.price"
          class="tile__prices-wrap"
          itemprop="price"
          :content="getMetaPrice(product.price.defaultPrice)"
        >
          <!-- Standard price + Your price -->
          <template v-if="settings.showDefaultPrices">
            <span class="tile__price tile__price--multi">
              <span class="tile__price-prefix">
                {{ dict["normal pris"] }}
                {{ product.variants > 1 ? dict["fra"] : "" }}
              </span>
              <span>{{ product.price.defaultPrice }}</span>
            </span>
            <span class="tile__price tile__price--multi tile__price--green">
              <span class="tile__price-prefix">
                {{ dict["din pris"] }}
                {{ product.variants > 1 ? dict["fra"] : "" }}
              </span>
              {{ product.price.price }}
            </span>
          </template>

          <!-- Single price -->
          <span v-else class="tile__price">
            <span v-if="product.variants > 1" class="tile__price-prefix">
              {{ dict["fra"] }}
            </span>
            <span>{{ product.price.price }}</span>
          </span>
        </span>
      </div>
    </div>

    <!-- Footer -->
    <div class="series series--small" v-if="product.brandName">
      <a
        v-if="product.brandLink"
        class="series__brand series__brand--link"
        :href="product.brandLink"
      >
        {{ product.brandName }}</a
      >
      <span v-else class="series__brand">{{ product.brandName }}</span>

      <template v-if="!collectionMode && product.collectionName && dict">
        <a class="series__link" :href="product.collectionUrl">
          <svg class="bi" width="16" height="16" fill="currentColor">
            <use href="../../static/bi-sprite.svg#plus" />
          </svg>
          {{
            dict["vis hele serien"].replace("{series}", product.collectionName)
          }}
        </a>
      </template>
    </div>
  </article>
</template>
<script>
import Vue from "vue";
import tracking from "../../js/utils/datalayer.js";

export default Vue.extend({
  name: "Tile",
  components: {},
  props: ["product", "settings", "dict", "collectionMode"],
  data() {
    return {
      host: window.location.host
    };
  },
  mounted() {},
  methods: {    
    image(thumbnail, params = "") {
      return thumbnail ? `${thumbnail}${params}` : "/public/fallback.gif";
    },
    onClick(product) {
      tracking.selectItem(product.item);
      this.setHistoryState();
    },
    setHistoryState() {
      window.history.replaceState(
        { scrollY: document.documentElement.scrollTop },
        document.title,
        window.location.pathname + window.location.search
      );
    },
    getMetaPrice(price) {
      return price.replace(".", "").replace(",", ".");
    }
  },
  computed: {}
});
</script>
